import { DevFeaturesDialogButton } from "@components/dev-features-dialog/dev-features-dialog-button";
import { FaroHelpCenterMenu } from "@components/header/faro-help-center-menu";
import { Searchbar } from "@components/header/searchbar";
import { UserMenu } from "@components/header/user-menu";
import { MainPageLayoutProps } from "@components/page-layout/main-page-layout";
import { ProgressOverviewMenu } from "@components/progress-overview/progress-overview-menu";
import { useMediaQueryList } from "@hooks/use-media-query";
import { useRouteMatch } from "@hooks/use-route-match";
import Grid2 from "@mui/material/Grid2";
import { Box } from "@mui/material";
import { useAppSelector } from "@store/store-helper";
import { loggedInUserSelector } from "@store/user/user-selector";

type Props = Pick<
  MainPageLayoutProps,
  "shouldShowProgressOverviewMenu" | "shouldShowUserMenu" | "shouldShowSearchbar"
>;

/** Content for the right side of layout header */
export function HeaderLayoutRight({
  shouldShowProgressOverviewMenu,
  shouldShowUserMenu,
  shouldShowSearchbar = true,
}: Props): JSX.Element {
  const { isScreenSmOrSmaller } = useMediaQueryList();
  const routeIdentifier = useRouteMatch();

  const loggedInUser = useAppSelector(loggedInUserSelector);

  return (
    <Grid2 container alignItems="center" justifyContent="right">
      {/* Search bar - always mounted to persist state, hidden on projects mobile */}
      <Box sx={{ display: routeIdentifier === "projects" && isScreenSmOrSmaller ? "none" : "block" }}>
        {shouldShowSearchbar && <Searchbar />}
      </Box>
      {/* Icons and buttons */}
      <Grid2
        container
        alignItems="center"
        // Use a smaller gap on small screens to save space
        gap={isScreenSmOrSmaller ? "0.25rem" : "1rem"}
      >
        <DevFeaturesDialogButton />

        <FaroHelpCenterMenu />

        {shouldShowProgressOverviewMenu && loggedInUser && (
          <ProgressOverviewMenu />
        )}

        {shouldShowUserMenu && <UserMenu />}
      </Grid2>
    </Grid2>
  );
}
